<template>
  <div>
    <div class="wrapper wrapper-content  animated fadeInRight">
      <div class="ibox">
        <div class="tabs-container">
          <a-modal modal-id="create-data-list">
            <div slot="title"> {{ dataList.id ? 'Edit': 'Create'}} Data List</div>
            <div slot="form">
                <div class="row">
                    <label>Name</label>
                    <input type="text" placeholder="Name for the data list" class="form-control" v-model="dataList.name">
                </div>
                <div class="row m-t-sm">
                    <label>Description</label>
                    <input type="text" placeholder="Description for the data list" class="form-control" v-model="dataList.description">
                </div>
                <div class="row m-t-sm">
                    <label for="name">Add Values</label>
                    <div v-for="(val, i) in dataList.values" :key="i + '-' + dataList.name" :class="'col-lg-12 m-b-sm ' + ((i === dataList.values.length - 1) ? 'green-left-border' : '')">
                        <div class="row m-t-xs">
                            <div class="col-lg-4">
                                <input type="text" placeholder="Index" v-model="val.index" class="form-control" :ref="'indexInput-' + i">
                            </div>
                            <div class="col-lg-4">
                                <input type="text" placeholder="Label" v-model="val.label" @keydown.enter="addValue()" class="form-control">
                            </div>
                            <div class="col-lg-2 buttons-container">
                               <button v-if="dataList.values.length - 1 === i" class="btn btn-success btn-sm" @click="addValue()" v-tooltip="'Add new value to the list'"><i class="fa fa-plus"></i></button>
                               <button class="btn btn-danger btn-sm" v-tooltip="'Remove value from list'" @click="removeValue(i)"><i class="fa fa-multiply"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <div v-if="dataList.id">
                    <button class="btn btn-danger" @click="deleteList(dataList)"><i class="fa fa-trash"></i> Delete</button>
                    <button class="btn btn-success" @click="saveDataList()"><i class="fa fa-save"></i> Update</button>
                </div>
                <button v-else class="btn btn-primary pull-right" @click="saveDataList()">Create List</button>
            </div>
          </a-modal>
          <div class="tab-content">
            <div  class="tab-pane ibox-content active" role="tabpanel" id="feed">
                <div class="row">
                  <div class="col-lg-12 m-t-sm">
                    <button class="btn btn-primary pull-right btn-sm" data-toggle="modal" data-target="#create-data-list" @click="initDataList()">
                        <i class="fa fa-plus"></i>
                        Add Data List
                    </button>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Values</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="l in lists" :key="l.id">
                                <td><strong>{{ l.name }}</strong></td>
                                <td>{{ l.description }}</td>
                                <td>
                                    <span v-for="(val, i) in l.values" :key="i" class="label label-primary m-r-xs">{{ val.label }}</span>
                                </td>
                                <td>
                                    <button class="btn btn-sm btn-danger pull-right m-l-xs" @click="deleteList(l)">
                                        <i class="fa fa-trash"></i> Delete
                                    </button>
                                    <button class="btn btn-sm btn-success pull-right" data-toggle="modal" data-target="#create-data-list" @click="dataList = JSON.parse(JSON.stringify(l))">
                                        <i class="fa fa-edit"></i> Edit
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      dataList: {
        name: '',
        description: '',
        values: [{'index': '', 'label': ''}]
      },
      lists: []
    }
  },
  mounted () {
    this.getLists()
  },
  methods: {
    addValue () {
      if (!this.dataList.values[this.dataList.values.length - 1].index.trim().length || !this.dataList.values[this.dataList.values.length - 1].label.trim().length) {
        this.$toastr.warning('Please fill the current value label index first before adding a new one!')
        return
      }

      this.dataList.values.push({'index': '', 'label': ''})
      this.$nextTick(() => {
        let inputRef = 'indexInput-' + (this.dataList.values.length - 1)
        this.$refs[inputRef][0].focus()
      })
    },
    removeValue (i) {
      if (this.dataList.values.length === 1) {
        this.$toastr.warning('Cannot remove the only value in the list')
        return
      }
      this.dataList.values.splice(i, 1)
    },
    initDataList () {
      this.dataList = {name: '', description: '', values: [{'index': '', 'label': ''}]}
    },
    async getLists () {
      try {
        let resp = await axios.get('/v2/data-structures')
        this.lists = resp.data
      } catch (error) {
        this.$toastr.error('Failed loading lists', error)
      }
    },
    async saveDataList () {
      if (!this.dataList.name.trim().length || !this.dataList.description.trim().length) {
        this.$toastr.warning('Name and Description cannot be empty')
        return
      }
      try {
        if (this.dataList.id) {
          await axios.patch(`/v2/data-structures/${this.dataList.id}`, this.dataList)
        } else {
          await axios.post('/v2/data-structures', this.dataList)
        }
        await this.getLists()
        this.$toastr.success('Lists Updated!')
        $('#create-data-list').modal('hide')
      } catch (error) {
        this.$toastr.error('Failed creating lists', error)
      }
    },
    async deleteList (list) {
      if (confirm(`Are you sure you want to delete ${list.name} ?`)) {
        await axios.delete(`/v2/data-structures/${list.id}`)
        await this.getLists()
        $('#create-data-list').modal('hide')
        this.$toastr.success('List deleted!')
      }
    }
  }
}
</script>
<style scoped>
.green-left-border {
  border-left: 5px solid #18a689;
}
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Admin/DataLists/DataLists.vue